import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { AddTipTapLinkModalComponent } from "./AddTipTapLinkModalComponent";
import { AddTipTapLinkModalUIKitComponent } from "./AddTipTapLinkModalUIKitComponent";

type AddTipTapLinkModalUIKitComponentProps = ComponentPropsWithoutRef<
  typeof AddTipTapLinkModalUIKitComponent
>;

const AddTipTapLinkModalUIKit = ModalManager.create(
  (props: AddTipTapLinkModalUIKitComponentProps) => (
    <AddTipTapLinkModalUIKitComponent {...props} />
  ),
);

type AddTipTapLinkModalComponentProps = Omit<
  ComponentPropsWithoutRef<typeof AddTipTapLinkModalComponent>,
  "open" | "onOpenChange"
>;

const AddTipTapLinkModal = ModalManager.create(
  (props: AddTipTapLinkModalComponentProps) => {
    const modal = useModal();

    return (
      <AddTipTapLinkModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            void modal.hide();
          }
        }}
      />
    );
  },
);

export const useAddTipTapLinkModal = () => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");
  const ModalComponent = isCircleV4
    ? AddTipTapLinkModal
    : AddTipTapLinkModalUIKit;

  return useModal(ModalComponent);
};
